﻿import React from "react";

export interface CardViewItemsProps<TItem> {
    items: TItem[];
    renderItem: (item: TItem, index: number) => React.ReactNode;
    colClass: string;
}

export class CardViewItems<TItem> extends React.Component<CardViewItemsProps<TItem>> {
    render(): React.ReactNode {
        return (
            <div className="row card-items">
                {this.props.items.map((item, index) =>
                    <div className={this.props.colClass} key={index}>
                        <div className="card">
                            {this.props.renderItem(item, index)}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}